import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { MultiRowCarouselState_s, SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const Percent = (props: {rowData: [], defaults: object, field: string, namedItems: [], persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")
  const areaMeasureOptions = _.map(
    _.filter(_.get(props, "namedItems.items"), item => item.areaid !== _.get(props, "rowData.areaid")),
    item => {
      return {value: item.areaid, label: item.code}
    }
  )

  const emptyRecord = {
    floor: null,
    cap: null
  }

  const emptyItem = {
    percent: null,
    areaMeasureNamedItemId: null
  }

  const [data, setData] = useState<object|null>(props.rowData[props.field]);
  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyItem, i: 0}]);

  function updateData(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data || {})
    if(newData && newData.amt) delete newData.amt

    if(_.isArray(field)) {
      if(items[field[0]][field[1]] === val) return
      items[field[0]][field[1]] = val
    } else {
      _.set(newData, field, val)
    }

    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'percent') _.set(newData, 'state', 'percent')
    setData(newData)
    props.persist(newData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let data = _.cloneDeep(props.rowData[props.field]);
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date");
    _.set(data, 'items', strippedItems);
    if (data.state !== 'percent') _.set(data, 'state', 'percent');
    props.persist(data, 'areadetail', props.rowData);
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateData
  }

  useEffect(() => {
    if (_.get(props['rowData'][props.field], "state") !== 'percent'){
      setData(emptyRecord)
      setItems([{...emptyItem, i: 0}])
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('area', props.field)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('area', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s style={{marginBottom: 10}} className="carousel-single-row">
        <div>
          <label>Floor</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="floor" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <label>Cap</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="cap" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
      { renderItems.map((row: object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Percent</label> }
              <NumberInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'percent']} {...params} readPrecision={2} writePrecision={2} persist={updateData} />
            </div>
            <div>
              { i === 0 && <label>Area Measure</label> }
              <DropdownInput className="automated area-measure-input" data={items} attrs={item_attrs} field={[`${row['i']}`, 'areaMeasureNamedItemId']} options={areaMeasureOptions} persist={updateData} />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default Percent
